import moment from "moment-timezone";
import { defaultColor } from "../constants/DefaultColor";
import { languages } from "../constants/languages";
import {
  socialImageDownload,
  TOURNAMENT_POSTER_IMAGE_URL,
} from "./socialImageDownload";

const POSTER_DATE_FORMAT = "D MMMM YYYY";
const DEFAULT_TIMEZONE = "Europe/Amsterdam";

const tournamentMoment = (unix, timezone) =>
  moment.unix(unix).tz(timezone || DEFAULT_TIMEZONE);

const formatPosterDate = (unix, timezone) => {
  const formatted = tournamentMoment(unix, timezone).format(POSTER_DATE_FORMAT);
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const formatTournamentPosterDate = (tournament, daysByKey = {}) => {
  if (!tournament.date) {
    return "";
  }
  const timezone = tournament.timezone;
  const startStr = formatPosterDate(tournament.date, timezone);
  const days = Object.values(daysByKey).sort((a, b) => a.date - b.date);
  if (days.length === 0) {
    return startStr;
  }
  const lastDate = days[days.length - 1].date;
  if (
    tournamentMoment(lastDate, timezone).isSame(
      tournamentMoment(tournament.date, timezone),
      "day",
    )
  ) {
    return startStr;
  }
  return `${startStr} - ${formatPosterDate(lastDate, timezone)}`;
};

export const formatTournamentPosterLocation = (tournament, sportParks = []) => {
  const cityLocation = [tournament.place, tournament.placeSecondaryName]
    .filter(Boolean)
    .join(", ");
  if (cityLocation) {
    return cityLocation;
  }
  const firstSportPark = sportParks[0];
  return (firstSportPark && firstSportPark.name) || "";
};

export const getTournamentPosterUrl = (tournament) => {
  if (!tournament.liveLink) {
    return null;
  }
  const base =
    tournament.isPSD || tournament.crqpsd
      ? "tournify.prosoccerdata.com/"
      : "tournifyapp.com/live/";
  return base + tournament.liveLink;
};

export const buildTournamentPosterPayload = (
  tournament,
  daysByKey = {},
  sportParks = [],
) => {
  const payload = {
    color: tournament.color || defaultColor,
    tournamentDate: formatTournamentPosterDate(tournament, daysByKey),
    tournamentTitle: tournament.name || "",
    tournamentLocation: formatTournamentPosterLocation(tournament, sportParks),
    language: languages.getLanguage() || "en",
  };

  const tournamentUrl = getTournamentPosterUrl(tournament);
  if (tournamentUrl) {
    payload.tournamentUrl = tournamentUrl;
  }

  if (tournament.bgURL) {
    payload.backgroundImage = tournament.bgURL;
  }
  if (tournament.logoURL) {
    payload.tournamentLogo = tournament.logoURL;
  }

  return payload;
};

export const downloadTournamentPoster = async (
  tournament,
  daysByKey = {},
  sportParks = [],
) => {
  const response = await fetch(TOURNAMENT_POSTER_IMAGE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(
      buildTournamentPosterPayload(tournament, daysByKey, sportParks),
    ),
  });

  const fileName = (tournament.name || "tournament") + "-poster.png";
  await socialImageDownload(response, fileName, false);
};
